import { defineMessages } from 'react-intl';

export default defineMessages({
	requests: {
		defaultMessage: 'Requests',
		description: 'Requests item in hub avatar menu',
		id: 'hub.avatar.menu.requests',
	},
	approvals: {
		defaultMessage: 'Approvals',
		description: 'Approvals item in hub avatar menu',
		id: 'hub.avatar.menu.approvals',
	},
	customiseHub: {
		defaultMessage: 'Customise help center',
		description: 'Customise hub item in hub avatar menu',
		id: 'hub.avatar.menu.customise.hub',
	},
	hubSettings: {
		defaultMessage: 'Help center settings',
		description: 'Hub settings item in hub avatar menu',
		id: 'hub.avatar.menu.hub.settings',
	},
});
